import { render, staticRenderFns } from "./idea.vue?vue&type=template&id=f68a13fc&scoped=true"
import script from "./idea.vue?vue&type=script&lang=js"
export * from "./idea.vue?vue&type=script&lang=js"
import style0 from "./idea.vue?vue&type=style&index=0&id=f68a13fc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f68a13fc",
  null
  
)

export default component.exports